import { render, staticRenderFns } from "./reviewResult.vue?vue&type=template&id=67a28822"
import script from "./reviewResult.vue?vue&type=script&lang=js"
export * from "./reviewResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports